import { platformStats } from '@/mocks/home';

export default function PlatformStatsSection() {
  return (
    <section className="relative py-16 md:py-22 overflow-hidden bg-gradient-to-br from-secondary-800 via-secondary-900 to-secondary-950">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-accent-500/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        {/* Top text area */}
        <div className="mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent-400/20 text-accent-300 text-xs font-semibold mb-5">
            <i className="ri-flashlight-line" />
            关于平台
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-2xl mb-4">
            吃瓜网站首页入口直达
            <br />
            全网最全吃瓜平台
          </h2>
          <p className="text-base text-background-50/70 leading-relaxed max-w-xl">
            整合51吃瓜网站、五一吃瓜网站等核心栏目，覆盖网红塌房、博主反差视频与网络热门事件最新爆料。
            每日大赛不停更，网红吃瓜网站最新地址一站直达。
          </p>
        </div>

        {/* Bottom split: image + stats */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left image */}
          <div className="w-full lg:w-2/5">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20minimalist%20composition%20with%20warm%20coral%20and%20cream%20tones%2C%20soft%20geometric%20shapes%20layered%20elegantly%2C%20contemporary%20editorial%20design%20aesthetic%2C%20clean%20sophisticated%20visual%2C%20light%20airy%20background%20with%20subtle%20texture%2C%20modern%20art%20gallery%20style%2C%20no%20text%20or%20lettering&width=800&height=800&seq=platform-stats-img&orientation=squarish"
              alt="吃瓜网站平台数据"
              className="w-full rounded-2xl object-cover object-top aspect-square"
              loading="lazy"
              title="吃瓜网站平台数据概览"
            />
          </div>

          {/* Right stats */}
          <div className="w-full lg:w-3/5">
            <div className="mb-6">
              <div className="font-heading text-7xl md:text-8xl font-bold text-accent-400 leading-none">
                {platformStats.monthlyVisitors}
              </div>
              <p className="text-base text-background-50/70 mt-2">月活跃用户数，持续增长中</p>
            </div>

            <div className="grid grid-cols-2 gap-4 md:gap-6 mb-8">
              <div className="bg-background-50/5 backdrop-blur-sm rounded-xl p-5 border border-background-50/10">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                  {platformStats.totalArticles}
                </div>
                <p className="text-xs text-background-50/60">累计爆料文章</p>
              </div>
              <div className="bg-background-50/5 backdrop-blur-sm rounded-xl p-5 border border-background-50/10">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                  {platformStats.dailyUpdates}
                </div>
                <p className="text-xs text-background-50/60">每日更新条数</p>
              </div>
              <div className="bg-background-50/5 backdrop-blur-sm rounded-xl p-5 border border-background-50/10">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                  {platformStats.totalComments}
                </div>
                <p className="text-xs text-background-50/60">累计评论数</p>
              </div>
              <div className="bg-background-50/5 backdrop-blur-sm rounded-xl p-5 border border-background-50/10">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                  24/7
                </div>
                <p className="text-xs text-background-50/60">全天候实时更新</p>
              </div>
            </div>

            <a
              href="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-accent-600 transition-all cursor-pointer"
            >
              立即开始吃瓜
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}